import request from '@/utils/request';

// 获取季度活动详情
export function get_activity_record_info(data) {
    return request({
        url: '/wap/quarter/get_activity_record_info',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}

// 获取季度活动中奖列表
export function get_activity_member_ticket_lists(data) {
    return request({
        url: '/wap/quarter/get_activity_member_ticket_lists',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}

// 获取季度活动兑换奖券
export function redeem_lottery(data) {
    return request({
        url: '/wap/quarter/redeem_lottery',
        method: 'post',
        data: data,
        headers: {
            needToken: true
        }
    });
}